// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
export const locales = [
  {
    "id": "en-US",
    "name": "English",
    "suffix": ""
  },
  {
    "id": "zh-CN",
    "name": "中文",
    "suffix": "-cn"
  }
];
export const messages = {
  "en-US": {
    "header.search.placeholder": "Type keywords...",
    "header.color.mode.light": "Light Mode",
    "header.color.mode.dark": "Dark Mode",
    "header.color.mode.auto": "Follow System",
    "header.social.github": "GitHub",
    "header.social.weibo": "Weibo",
    "header.social.twitter": "Twitter",
    "header.social.x": "X",
    "header.social.gitlab": "GitLab",
    "header.social.facebook": "Facebook",
    "header.social.zhihu": "Zhihu",
    "header.social.yuque": "Yuque",
    "header.social.linkedin": "Linkedin",
    "previewer.actions.code.expand": "Show Code",
    "previewer.actions.code.shrink": "Hide Code",
    "previewer.actions.code.editable": "Edit code with real-time preview",
    "previewer.actions.code.readonly": "Only index file is editable",
    "previewer.actions.sketch": "Copy to Sketch app",
    "previewer.actions.sketch.group": "Copy as Sketch Group",
    "previewer.actions.sketch.symbol": "Copy as Sketch Symbol",
    "previewer.actions.sketch.divider": "------------------------",
    "previewer.actions.sketch.guide": "How to paste to Sketch?",
    "previewer.actions.codesandbox": "Open in CodeSandbox",
    "previewer.actions.codepen": "Open in CodePen (Not implemented)",
    "previewer.actions.stackblitz": "Open in StackBlitz",
    "previewer.actions.separate": "Open in separate page",
    "404.title": "PAGE NOT FOUND",
    "404.back": "Back to homepage",
    "api.component.name": "Name",
    "api.component.description": "Description",
    "api.component.type": "Type",
    "api.component.default": "Default",
    "api.component.required": "(required)",
    "api.component.release.alpha": "Alpha",
    "api.component.release.beta": "Beta",
    "api.component.release.experimental": "Experimental",
    "api.component.release.deprecated": "Deprecated",
    "api.component.unavailable": "apiParser must be enabled to use auto-generated API",
    "api.component.loading": "Properties definition is resolving, wait a moment...",
    "api.component.not.found": "Properties definition not found for {id} component",
    "content.tabs.default": "Doc",
    "content.footer.last.updated": "Last updated: ",
    "content.footer.actions.edit": "Improve this documentation",
    "content.footer.actions.previous": "PREV",
    "content.footer.actions.next": "NEXT",
    "search.not.found": "No content was found",
    "search.loading": "Loading...",
    "layout.sidebar.btn": "Sidebar",
    "app.theme.switch.dynamic": "Dynamic Theme",
    "app.theme.switch.default": "Default theme",
    "app.theme.switch.dark": "Dark theme",
    "app.theme.switch.compact": "Compact theme",
    "app.theme.switch.motion.on": "Motion On",
    "app.theme.switch.motion.off": "Motion Off",
    "app.theme.switch.happy-work.on": "Happy Work Effect On",
    "app.theme.switch.happy-work.off": "Happy Work Effect Off",
    "app.header.search": "Search...",
    "app.header.menu.documentation": "Docs",
    "app.header.menu.more": "More",
    "app.header.menu.mobile": "Mobile",
    "app.header.menu.pro.v4": "Ant Design Pro",
    "app.header.menu.pro.components": "Ant Design Pro Components",
    "app.header.menu.charts": "Ant Design Charts",
    "app.header.menu.ecosystem": "Ecosystem",
    "app.header.lang": "中文",
    "app.content.edit-page": "Edit this page on GitHub!",
    "app.content.edit-demo": "Edit this demo on GitHub!",
    "app.content.contributors": "contributors",
    "app.component.examples": "Examples",
    "app.component.examples.expand": "Expand all code",
    "app.component.examples.collapse": "Collapse all code",
    "app.component.examples.visible": "Expand debug examples",
    "app.component.examples.hide": "Collapse debug examples",
    "app.component.examples.openDemoNotReact18": "Open Demo with React < 18",
    "app.component.examples.openDemoWithReact18": "Open Demo with React 18",
    "app.demo.debug": "Debug only, won't display at online",
    "app.demo.copy": "Copy code",
    "app.demo.copied": "Copied!",
    "app.demo.code.show": "Show code",
    "app.demo.code.hide": "Hide code",
    "app.demo.code.hide.simplify": "Hide",
    "app.demo.codepen": "Open in CodePen",
    "app.demo.codesandbox": "Open in CodeSandbox",
    "app.demo.stackblitz": "Open in Stackblitz",
    "app.demo.riddle": "Open in Riddle",
    "app.demo.separate": "Open in a new window",
    "app.demo.online": "Online Address",
    "app.home.introduce": "A design system for enterprise-level products. Create an efficient and enjoyable work experience.",
    "app.home.pr-welcome": "💡 It is an alpha version and still in progress. Contribution from community is welcome!",
    "app.home.recommend": "Recommended",
    "app.home.popularize": "Popular",
    "app.home.design-and-framework": "Design language and framework",
    "app.home.design-values": "Design values",
    "app.home.design-values-description": "This is Ant Design's internal standard for evaluating design quality. Based on the assumption that \"everyone is pursuing happiness at work\", we have added the two values of \"Meaningfulness\" and \"Growth\" on the basis of \"Certainty\" and \"Naturalness\" to guide each designer towards better judgment and decision-making.",
    "app.home.certainty": "Certainty",
    "app.home.meaningful": "Meaningfulness",
    "app.home.growth": "Growth",
    "app.home.natural": "Naturalness",
    "app.home.design-guide": "Guidelines",
    "app.home.components": "Components",
    "app.home.detail": "More details",
    "app.home.global-style": "Global style",
    "app.home.design-patterns": "Design patterns",
    "app.home.more": "Learn More",
    "app.home.getting-started": "Getting Started",
    "app.home.design-language": "Design Language",
    "app.home.product-antv-slogan": "A new way to do data visualization",
    "app.home.product-pro-slogan": "Out-of-the-box UI solution for enterprise applications",
    "app.home.product-mobile-slogan": "Mobile UI components with Ant Design",
    "app.home.product-hitu": "HiTu",
    "app.home.product-hitu-slogan": "A new generation of graphical solutions",
    "app.home.product-kitchen-slogan": "A Sketch plugin to enhance designers",
    "app.home.product-icons-slogan": "A set of premium icons",
    "app.home.view-more": "More",
    "app.footer.repo": "GitHub Repository",
    "app.footer.awesome": "Awesome Ant Design",
    "app.footer.course": "Ant Design Practical Tutorial",
    "app.footer.chinamirror": "China Mirror 🇨🇳",
    "app.footer.primary-color-changing": "Changing primary color...",
    "app.footer.primary-color-changed": "Changed primary color successfully!",
    "app.footer.scaffold": "Scaffold",
    "app.footer.kitchen": "Sketch Toolkit",
    "app.footer.landing": "Landing Templates",
    "app.footer.scaffolds": "Scaffold Market",
    "app.footer.dev-tools": "Developer Tools",
    "app.footer.umi": "React Application Framework",
    "app.footer.dumi": "Component doc generator",
    "app.footer.qiankun": "Micro-Frontends Framework",
    "app.footer.hooks": "React Hooks Library",
    "app.footer.resources": "Resources",
    "app.footer.data-vis": "Data Visualization",
    "app.footer.eggjs": "Enterprise Node Framework",
    "app.footer.motion": "Motion Solution",
    "app.footer.community": "Community",
    "app.footer.help": "Help",
    "app.footer.change-log": "Change Log",
    "app.footer.theme": "Theme Editor",
    "app.footer.faq": "FAQ",
    "app.footer.feedback": "Feedback",
    "app.footer.stackoverflow": "StackOverflow",
    "app.footer.segmentfault": "SegmentFault",
    "app.footer.discussions": "Discussions",
    "app.footer.bug-report": "Bug Report",
    "app.footer.issues": "Issues",
    "app.footer.version": "Version: ",
    "app.footer.author": "Created by XTech",
    "app.footer.work_with_us": "Work with Us",
    "app.footer.more-product": "More Products",
    "app.footer.company": "XTech",
    "app.footer.ant-design": "UI Design Language",
    "app.footer.yuque": "YuQue",
    "app.footer.yuque.slogan": "Document Collaboration Platform",
    "app.footer.antv.slogan": "Data Visualization",
    "app.footer.egg.slogan": "Enterprise Node.js Framework",
    "app.footer.yuque.repo": "Ant Design in YuQue",
    "app.footer.zhihu": "Ant Design in Zhihu",
    "app.footer.zhihu.xtech": "Experience Cloud Blog",
    "app.footer.seeconf": "Experience Tech Conference",
    "app.footer.xtech": "Ant Financial Experience Tech",
    "app.footer.xtech.slogan": "Experience The Beauty",
    "app.footer.galacean": "Galacean",
    "app.footer.galacean.slogan": "Interactive Graphics Solution",
    "app.docs.color.pick-primary": "Pick your primary color",
    "app.docs.color.pick-background": "Pick your background color",
    "app.docs.components.icon.search.placeholder": "Search icons here, click icon to copy code",
    "app.docs.components.icon.outlined": "Outlined",
    "app.docs.components.icon.filled": "Filled",
    "app.docs.components.icon.two-tone": "Two Tone",
    "app.docs.components.icon.category.direction": "Directional Icons",
    "app.docs.components.icon.category.suggestion": "Suggested Icons",
    "app.docs.components.icon.category.editor": "Editor Icons",
    "app.docs.components.icon.category.data": "Data Icons",
    "app.docs.components.icon.category.other": "Application Icons",
    "app.docs.components.icon.category.logo": "Brand and Logos",
    "app.docs.resource.design": "Design",
    "app.docs.resource.develop": "Develop",
    "app.components.overview.search": "Search in components",
    "app.implementation.community": "community",
    "app.implementation.official": "official"
  },
  "zh-CN": {
    "header.search.placeholder": "输入关键字搜索...",
    "header.color.mode.light": "亮色模式",
    "header.color.mode.dark": "暗色模式",
    "header.color.mode.auto": "跟随系统",
    "header.social.github": "GitHub",
    "header.social.weibo": "微博",
    "header.social.twitter": "Twitter",
    "header.social.x": "X",
    "header.social.gitlab": "GitLab",
    "header.social.facebook": "Facebook",
    "header.social.zhihu": "知乎",
    "header.social.yuque": "语雀",
    "header.social.linkedin": "Linkedin",
    "previewer.actions.code.expand": "展开代码",
    "previewer.actions.code.shrink": "收起代码",
    "previewer.actions.code.editable": "编辑代码可实时预览",
    "previewer.actions.code.readonly": "仅 index 可编辑",
    "previewer.actions.codesandbox": "在 CodeSandbox 中打开",
    "previewer.actions.sketch": "拷贝到 Sketch",
    "previewer.actions.sketch.group": "拷贝为 Sketch Group",
    "previewer.actions.sketch.symbol": "拷贝为 Sketch Symbol",
    "previewer.actions.sketch.divider": "----------------------",
    "previewer.actions.sketch.guide": "如何粘贴到 SKetch？",
    "previewer.actions.stackblitz": "在 StackBlitz 中打开",
    "previewer.actions.separate": "在独立页面中打开",
    "404.title": "页面未找到",
    "404.back": "返回首页",
    "api.component.name": "属性名",
    "api.component.description": "描述",
    "api.component.type": "类型",
    "api.component.default": "默认值",
    "api.component.required": "(必选)",
    "api.component.release.alpha": "Alpha",
    "api.component.release.beta": "Beta",
    "api.component.release.experimental": "实验性",
    "api.component.release.deprecated": "废弃",
    "api.component.unavailable": "必须启用 apiParser 才能使用自动 API 特性",
    "api.component.loading": "属性定义正在解析中，稍等片刻...",
    "api.component.not.found": "未找到 {id} 组件的属性定义",
    "content.tabs.default": "文档",
    "content.footer.last.updated": "最后更新时间：",
    "content.footer.actions.edit": "帮助改进此文档",
    "content.footer.actions.previous": "上一篇",
    "content.footer.actions.next": "下一篇",
    "search.not.found": "未找到相关内容",
    "search.loading": "加载中...",
    "layout.sidebar.btn": "侧边菜单",
    "app.theme.switch.dynamic": "动态主题",
    "app.theme.switch.default": "默认主题",
    "app.theme.switch.dark": "暗黑主题",
    "app.theme.switch.compact": "紧凑主题",
    "app.theme.switch.motion.on": "动画开启",
    "app.theme.switch.motion.off": "动画关闭",
    "app.theme.switch.happy-work.on": "快乐工作特效开启",
    "app.theme.switch.happy-work.off": "快乐工作特效关闭",
    "app.header.search": "全文本搜索...",
    "app.header.menu.documentation": "文档",
    "app.header.menu.more": "更多",
    "app.header.menu.mobile": "移动版",
    "app.header.menu.pro.v4": "Ant Design Pro",
    "app.header.menu.pro.components": "Ant Design Pro Components",
    "app.header.menu.charts": "Ant Design Charts",
    "app.header.menu.ecosystem": "生态",
    "app.header.lang": "English",
    "app.content.edit-page": "在 GitHub 上编辑此页！",
    "app.content.edit-demo": "在 GitHub 上编辑此示例！",
    "app.content.contributors": "文档贡献者",
    "app.component.examples": "代码演示",
    "app.component.examples.expand": "展开全部代码",
    "app.component.examples.collapse": "收起全部代码",
    "app.component.examples.visible": "显示调试专用演示",
    "app.component.examples.hide": "隐藏调试专用演示",
    "app.component.examples.openDemoNotReact18": "使用 React 18 以下版本打开 Demo",
    "app.component.examples.openDemoWithReact18": "使用 React 18 打开 Demo",
    "app.demo.debug": "此演示仅供调试，线上不会展示",
    "app.demo.copy": "复制代码",
    "app.demo.copied": "复制成功",
    "app.demo.code.show": "显示代码",
    "app.demo.code.hide": "收起代码",
    "app.demo.code.hide.simplify": "收起",
    "app.demo.codepen": "在 CodePen 中打开",
    "app.demo.codesandbox": "在 CodeSandbox 中打开",
    "app.demo.stackblitz": "在 Stackblitz 中打开",
    "app.demo.riddle": "在 Riddle 中打开",
    "app.demo.separate": "在新窗口打开",
    "app.demo.online": "线上地址",
    "app.home.introduce": "企业级产品设计体系，创造高效愉悦的工作体验",
    "app.home.pr-welcome": "💡 当前为 alpha 版本，仍在开发中。欢迎社区一起共建，让 Ant Design 变得更好！",
    "app.home.recommend": "精彩推荐",
    "app.home.popularize": "推广",
    "app.home.design-and-framework": "设计语言与研发框架",
    "app.home.design-values": "设计价值观",
    "app.home.design-values-description": "这是 Ant Design 评价设计好坏的内在标准。基于「每个人都追求快乐工作」这一假定，我们在「确定性」和「自然」的基础上，新增「意义感」和「生长性」两个价值观，指引每个设计者做更好地判断和决策。",
    "app.home.certainty": "确定性",
    "app.home.meaningful": "意义感",
    "app.home.growth": "生长性",
    "app.home.natural": "自然",
    "app.home.design-guide": "设计指引",
    "app.home.components": "组件库",
    "app.home.detail": "查看详情",
    "app.home.global-style": "全局样式",
    "app.home.design-patterns": "设计模式",
    "app.home.more": "更多内容",
    "app.home.getting-started": "开始使用",
    "app.home.design-language": "设计语言",
    "app.home.product-antv-slogan": "全新一代数据可视化解决方案",
    "app.home.product-pro-slogan": "开箱即用的中台前端/设计解决方案",
    "app.home.product-mobile-slogan": "基于 Preact / React / React Native 的 UI 组件库",
    "app.home.product-hitu": "海兔",
    "app.home.product-hitu-slogan": "全新一代图形化解决方案",
    "app.home.product-kitchen-slogan": "一款为设计者提升工作效率的 Sketch 工具集",
    "app.home.product-icons-slogan": "一整套优质的图标集",
    "app.home.view-more": "查看全部",
    "app.footer.repo": "GitHub 仓库",
    "app.footer.awesome": "Awesome Ant Design",
    "app.footer.chinamirror": "国内镜像站点 🇨🇳",
    "app.footer.primary-color-changing": "正在修改主题色...",
    "app.footer.primary-color-changed": "修改主题色成功！",
    "app.footer.kitchen": "Sketch 工具集",
    "app.footer.landing": "首页模板集",
    "app.footer.scaffold": "脚手架",
    "app.footer.scaffolds": "脚手架市场",
    "app.footer.dev-tools": "开发工具",
    "app.footer.umi": "React 应用开发框架",
    "app.footer.dumi": "组件/文档研发工具",
    "app.footer.qiankun": "微前端框架",
    "app.footer.hooks": "React Hooks 库",
    "app.footer.resources": "相关资源",
    "app.footer.data-vis": "数据可视化",
    "app.footer.eggjs": "企业级 Node 开发框架",
    "app.footer.motion": "设计动效",
    "app.footer.community": "社区",
    "app.footer.help": "帮助",
    "app.footer.change-log": "更新日志",
    "app.footer.theme": "主题编辑器",
    "app.footer.faq": "常见问题",
    "app.footer.feedback": "反馈和建议",
    "app.footer.stackoverflow": "StackOverflow",
    "app.footer.segmentfault": "SegmentFault",
    "app.footer.discussions": "讨论区",
    "app.footer.bug-report": "报告 Bug",
    "app.footer.issues": "议题",
    "app.footer.version": "文档版本：",
    "app.footer.author": "蚂蚁集团体验技术部出品 @ XTech",
    "app.footer.work_with_us": "加入我们",
    "app.footer.more-product": "更多产品",
    "app.footer.company": "XTech",
    "app.footer.ant-design": "蚂蚁 UI 体系",
    "app.footer.yuque": "语雀",
    "app.footer.yuque.slogan": "构建你的数字花园",
    "app.footer.antv.slogan": "数据可视化解决方案",
    "app.footer.egg.slogan": "企业级 Node.js 框架",
    "app.footer.yuque.repo": "Ant Design 语雀专栏",
    "app.footer.zhihu": "Ant Design 知乎专栏",
    "app.footer.zhihu.xtech": "体验科技专栏",
    "app.footer.seeconf": "蚂蚁体验科技大会",
    "app.footer.xtech": "蚂蚁体验科技",
    "app.footer.xtech.slogan": "让用户体验美好",
    "app.footer.galacean": "Galacean",
    "app.footer.galacean.slogan": "互动图形解决方案",
    "app.docs.color.pick-primary": "选择你的主色",
    "app.docs.color.pick-background": "选择你的背景色",
    "app.docs.components.icon.search.placeholder": "在此搜索图标，点击图标可复制代码",
    "app.docs.components.icon.outlined": "线框风格",
    "app.docs.components.icon.filled": "实底风格",
    "app.docs.components.icon.two-tone": "双色风格",
    "app.docs.components.icon.category.direction": "方向性图标",
    "app.docs.components.icon.category.suggestion": "提示建议性图标",
    "app.docs.components.icon.category.editor": "编辑类图标",
    "app.docs.components.icon.category.data": "数据类图标",
    "app.docs.components.icon.category.other": "网站通用图标",
    "app.docs.components.icon.category.logo": "品牌和标识",
    "app.docs.resource.design": "设计",
    "app.docs.resource.develop": "开发",
    "app.components.overview.search": "搜索组件",
    "app.implementation.community": "社区实现",
    "app.implementation.official": "官方"
  }
};
